import { dehydrateApolloClient, initApolloClient } from "../apolloClient";
import {
  GET_RESIDENTIAL_STATS_CONFIG,
  GET_STATS,
} from "@/graphql/queries/statisitcal";
import {
  GET_ALL_CITIES,
  GET_ALL_DIRECTIONS,
  GET_ALL_DISTRICTS,
} from "@/graphql/queries/regions";

export const configToCategoryMap = (config) => {
  const categoryObject = {};

  Object.keys(config).forEach((key) => {
    if (Array.isArray(config[key])) {
      config[key].forEach((category) => {
        categoryObject[category.category] = { ...category, type: key };
      });
    }
  });

  return categoryObject;
};

export const ResidentialIndicators = {
  ResolveConfig: async (ctx) => {
    const client = initApolloClient();
    const { data } = await client.query({
      query: GET_RESIDENTIAL_STATS_CONFIG,
    });
    ctx.path.mode = "residential_stats_filters";
    ctx.path.ssr = true;
    ctx.path.basePath = "/الإحصائيات-العقارية";
    ctx.path.residentialStatsConfig =
      data?.Info?.configurations?.residential_stats;
    ctx.path.statsCategoryMap = configToCategoryMap(
      ctx.path.residentialStatsConfig,
    );
    ctx.path.isStatResults = false;
    return {};
  },
  ResolveStatsCategory: async (ctx, $res) => {
    const { categories } = await import("./ssr/categories");
    const [category, plus] = (ctx?.query?.params || []).map(decodeURI);

    ctx.path.isStatResults = false;

    if (!ctx.path.categories) {
      ctx.path.categories = Object.keys(categories)
        .map((key) => categories[key])
        .map((cat, i) => ({ ...cat, index: cat.id > 100 ? cat.id - 100 : i }));
    }
    if (!ctx.path.categoriesDictionary) {
      ctx.path.categoriesDictionary = ctx.path.categories.reduce(
        (acc, cat) => ({ ...acc, [cat.id]: cat }),
        {},
      );
    }

    if (category && !categories[category]) {
      return ctx.redirect("/");
    }

    if (category && !ctx.path.statsCategoryMap[categories[category]?.id]) {
      return ctx.redirect("/");
    }

    ctx.path.category = categories[category || "عقارات"];

    if (plus) {
      return {};
    }

    const client = initApolloClient();
    await client.query({
      query: GET_ALL_CITIES,
      variables: {
        category: categories[category]?.id || 0,
      },
    });

    return $res(dehydrateApolloClient(client, {}));
  },
  ResolveCity: async (ctx, $res) => {
    const { cities } = await import("./ssr/cities");
    const [, city, plus] = ctx?.query?.params || [];
    if (!city) throw ` مدينة غير موجودة `;
    if (!cities[city]) throw ` مدينة غير موجودة `;
    ctx.path.city = cities[city];
    ctx.path.isStatResults = false;

    if (plus) return {};
    const client = initApolloClient();
    await client.query({
      query: ctx.path.city.directions ? GET_ALL_DIRECTIONS : GET_ALL_DISTRICTS,
      variables: {
        category: ctx.path.category.id,
        city_id: ctx.path.city.id,
      },
    });

    return $res(dehydrateApolloClient(client, {}));
  },
  ResolveStats: async (ctx, $res) => {
    const params = ctx?.query?.params || [];
    if (params[params.length - 1] !== "المؤشرات") {
      return {};
    }

    ctx.path.isStatResults = true;

    const client = initApolloClient();
    await client.query({
      query: GET_STATS,
      context: {
        token: ctx.authState?.token,
      },
      variables: {
        district_id: ctx.path.district.id,
        category: ctx.path.category.id,
        period_type: "semiannually",
        size: ctx?.query.size || "",
      },
    });

    return $res(dehydrateApolloClient(client, {}));
  },
};
